export default {"src":"/_next/static/media/mongolia.f50389b2.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};